<script>
import { ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import Carousel from "primevue/carousel";
import Skeleton from "primevue/skeleton";
import uploadPhotoService from "@shared/services/uploadPhoto.service";
import PolicyModal from "./components/PolicyModalComponent";
import configurationService from "@shared/services/configuration.service";

import { required, email, helpers } from "@vuelidate/validators";

import { mapActions } from "pinia";
import { authMethods, notificationMethods } from "@shared/state/helpers";
import { useAuthStore } from "@shared/stores/auth.store";
import { useDataStore } from "@shared/stores/data.store";

export default {
  components: {
    Carousel,
    Skeleton,
    PolicyModal,
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore, v$: useVuelidate() };
  },
  data() {
    return {
      iconPassword: "ri-eye-line",
      passwordType: "password",
      hotline: null,
      contactDialog: false,
      visiblePolicy: false,
      visibleSecurity: false,
      contact: ref([]),
      email: ref(""),
      password: ref(""),
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      processing: false,
      showInput: false,
      dataBanner: ref([]),
      urlLogo: null,
      typeBanner: "banner-login",
      typeLogo: "logo-login",
      remember: false,
    };
  },

  created() {
    this.getData();
    this.getDataLogo();
    this.checkRememberedLogin();
  },
  computed: {
    ...mapActions(useDataStore, [
      "initializeData",
      "getSetting",
      "fetchConfigs",
    ]),

    ...mapActions(useAuthStore, ["setPem"]),
    validInput() {
      return this.email && this.password ? true : false;
    },
    disableButton() {
      return this.processing || !this.validInput;
    },
  },

  validations() {
    return {
      email: {
        required: helpers.withMessage(
          this.$t("global.email_not_empty"),
          required
        ),
        email: helpers.withMessage(this.$t("global.email_not_empty"), email),
      },
      password: {
        required: helpers.withMessage(
          this.$t("global.password_not_empty"),
          required
        ),
      },
    };
  },

  watch: {
    email() {
      // Recheck validInput if email changes
      this.disableButton;
    },
    password() {
      // Recheck validInput if password changes
      this.disableButton;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    switchPasswordType(){
      this.passwordType = this.passwordType === "password" ? "text" : "password";
      this.iconPassword = this.passwordType === "password" ? "ri-eye-line" : "ri-eye-off-line";
    },
    checkRememberedLogin() {
      const rememberedEmail = localStorage.getItem("rememberedEmail");
      const rememberedPassword = localStorage.getItem("rememberedPassword");

      if (rememberedEmail && rememberedPassword) {
        this.email = rememberedEmail;
        this.password = rememberedPassword;
        this.remember = true;
      }
    },

    async validateForm() {
      const result = await this.v$.$validate();
      if (!result) {
        return this.v$.$errors.map((error) => error.$message);
      }
      return [];
    },
    async signinapi() {
      this.authError = await this.validateForm();
      if (this.authError.length > 0) {
        this.isLoading = false;
        return;
      }
      this.authError = null;
      this.processing = true;
      this.isAuthError = false;

      this.toggleLoading(this.$refs.loginForm);
      this.authStore
        .login({ email: this.email, password: this.password })
        .then((rp) => {
          if (this.remember) {
            console.log("rp",rp);
            console.log("remember",this.remember);
            // Lưu thông tin đăng nhập vào localStorage
            localStorage.setItem("rememberedEmail", this.email);
            localStorage.setItem("rememberedPassword", this.password);
          } else {
            // Xóa localStorage nếu không chọn remember
            localStorage.removeItem("rememberedEmail");
            localStorage.removeItem("rememberedPassword");
          }

          this.toggleLoading(this.$refs.loginForm);

          this.initializeData;
          this.fetchConfigs;
          this.getSetting;
          this.processing = false;

          let urlParams = new URLSearchParams(
            new URL(window.location.href).search
          );
          if (urlParams.get("next")) {
            window.location.href = urlParams.get("next");
          } else {
            this.$router.push("/");
          }
        })
        .catch((rs) => {
          this.toggleLoading(this.$refs.loginForm);
          const seft = this;
          if (rs.data.errors != undefined) {
            Object.values(rs.data.errors).forEach((item) => {
              this.$showToast(seft.$t("global." + seft._e(item)), {
                type: "error",
              });
            });
          }

          this.processing = false;
          this.isAuthError = true;
        });
    },
    async getData() {
      const conditionsBanner = {
        status: 1,
        type: this.typeBanner,
      };
      uploadPhotoService.getBanner(conditionsBanner).then((response) => {
        this.dataBanner = response.data.data;
      });
      await configurationService.getPublicConfig().then((setting) => {
        this.hotline =
          setting.data.content.company.children.general.children.phone.value;

        this.contact = Object.values(
          setting.data.content.company.children.general.children.contact.value
        ).map((item) => {
          if(item.svg)item.svg = item.svg.replace(/<\?xml.*?\?>/, ""); // Loại bỏ khai báo XML
          return item;
        });

       
      });
    },
    async getDataLogo() {
      try {
        const response = await uploadPhotoService.getItem(this.typeLogo);
        if (response.data.data) {
          this.urlLogo = this.imageLink(
            this.typeLogo + "/" + response.data.data.name_file
          );
        }
      } catch (error) {
        console.error("Error while fetching data:", error);
      }
    },
  },
};
</script>

<template>
  <PolicyModal
    @update:visible="visiblePolicy = $event"
    :visible="visiblePolicy"
  />
  <PolicyModal
    @update:visible="visibleSecurity = $event"
    :visible="visibleSecurity"
    type="security"
  />
  <Dialog
    v-model:visible="contactDialog"
    modal
    :pt="{
      root: 'border-none',
      mask: {
        style: 'backdrop-filter: blur(2px)',
      },
    }"
    :style="{ width: '90%', maxWidth: '600px' }"
  >
    <template #container="{ closeCallback }">
      <div class="card m-0">
        <div
          class="card-header bg-surface d-flex align-items-center justify-content-between"
        >
          <span class="fs-4 fw-semibold">{{ $t("login.contact") }}</span>
          <span class="cursor-pointer" @click="closeCallback">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <path
                d="M3.66666 3.66699L18.3333 18.3337"
                stroke="#535D65"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.66666 18.3337L18.3333 3.66699"
                stroke="#535D65"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
        <ul class="list-group list-group-flush">
          <li
            v-for="(item, index) in this.contact"
            v-bind:key="index"
            class="list-group-item"
          >
            <div v-if="item?.svg" class="d-flex justify-content-start gap-3 align-items-center">
              <span class="svg-icon">
                <img :src="this.url(item?.svg)" />
              </span>
              <a :href="item?.link" class="fs-5 text-black" target="_blank">{{
                item?.name
              }}</a>
            </div>
          </li>
        </ul>
      </div>
    </template>
  </Dialog>
  <div class="auth-page-wrapper">
    <div class="auth-page-content bg-gray">
      <BRow>
        <BCol class="mt-0 px-0 d-none d-md-block" lg="8" xl="8 " md="8 ">
          <div class="banner-login">
            <div v-if="this.dataBanner.length">
              <Carousel
                :value="this.dataBanner"
                :numVisible="1"
                :numScroll="1"
                circular:false
                :autoplayInterval="3000"
                :showNavigators="false"
                :showIndicators="false"
              >
                <template #item="slotProps">
                  <div class="">
                    <div v-if="slotProps.data.link">
                      <router-link :to="slotProps.data.link" class="text-reset">
                        <img
                          :src="
                            this.imageLink(
                              this.typeBanner + '/' + slotProps.data.name_file
                            )
                          "
                          :alt="slotProps.data.link"
                          class="w-full h-full"
                        />
                      </router-link>
                    </div>
                    <div v-else>
                      <img
                        :src="
                          this.imageLink(
                            this.typeBanner + '/' + slotProps.data.name_file
                          )
                        "
                        :alt="slotProps.data.link"
                        class="w-full h-full"
                      />
                    </div>
                  </div>
                </template>
              </Carousel>
            </div>
            <div v-else></div>
          </div>
        </BCol>
        <BCol md="4" lg="4" xl="4" class="p-0">
          <BCard no-body class="p-1 p-md-4 bg-login">
            <div class="wrap-login-panel" ref="loginForm">
              <div class="text-end mb-3">
                <div class="dropdown">
                  <a
                    href="#"
                    class="btn btn-primary dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <inline-svg
                      src="assets/icon/support.svg"
                      width="33"
                      height="24"
                      fill="black"
                    ></inline-svg>
                    {{ $t("login.support247") }}
                  </a>
                  <ul class="dropdown-menu">
                    <li v-if="hotline != null">
                      <a
                        class="dropdown-item text-primary fw-bold"
                        :href="`tel:${hotline}`"
                        >{{ hotline }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="text-center mb-4 text-white-50">
                <div>
                  <router-link to="/" class="d-inline-block auth-logo">
                    <img
                      v-if="urlLogo"
                      :src="urlLogo"
                      alt=""
                      width="200"
                      height="200"
                      style="max-width: 100%"
                    />
                    <template v-else>
                      <Skeleton shape="circle" size="165px"></Skeleton>
                    </template>
                  </router-link>
                </div>
              </div>
              <div class="text-center mt-2 title-login">
                <h2 class="m-0 wsp">
                  {{ $t("login.login_heading") }}
                </h2>

                <p class="m-0 my-2">{{ $t("login.login_desc") }}</p>
              </div>
              <div class="p-2 mt-2">
                <form @submit.prevent="tryToLogIn">
                  <div class="mb-3">
                    <label for="email" class="form-label">Email</label>
                    <div class="position-relative auth-pass-inputgroup ">
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="Enter email"
                      v-model="email"
                    />
                    
                    <span @click="email = ''" v-if="email" class="cursor-pointer position-absolute top-50 end-0 translate-middle-y me-2">
                    <i class=" ri-close-line fs-3"></i>
                    </span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="password-input"
                      >Password</label>
                    
                    <div class="position-relative auth-pass-inputgroup mb-3">
                      <input
                        :type="passwordType"
                        v-model="password"
                        class="form-control pe-5"
                        placeholder="Enter password"
                        id="password-input"
                      />
                      <span class="position-absolute top-50 end-0 translate-middle-y me-2">
                      <span @click="password = ''" v-if="password" class="cursor-pointer  end-0 translate-middle-y me-2">
                      <i class=" ri-close-line fs-3"></i>
                      </span>
                      <span @click="switchPasswordType()" class="cursor-pointer  end-0 translate-middle-y me-2">
                      <i class="fs-3" :class="iconPassword"></i>
                      </span>
                    </span>
                      
                    </div>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="1"
                      v-model="remember"
                      id="auth-remember-check"
                    />
                    <label class="form-check-label" for="auth-remember-check">{{
                      $t("login.remember")
                    }}</label>
                  </div>
                  <div class="mt-4">
                    <button
                      class="w-100 btn-primary btn"
                      type="submit"
                      @click.prevent="signinapi"
                      :disabled="disableButton"
                      :loading="processing"
                      loadingText="Please wait "
                    >
                      {{ $t("login.login") }}
                    </button>
                  </div>
                  <div class="py-3 link-remember">
                    <div
                      class="d-flex justify-between align-content-center align-items-center"
                    >
                      <div class="col">
                        <router-link
                          :to="{ name: 'app.login.forgot_password' }"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Icon/22/card">
                              <path
                                id="Vector"
                                d="M19.25 3.66663H2.74998C2.24372 3.66663 1.83331 4.07703 1.83331 4.58329V17.4166C1.83331 17.9229 2.24372 18.3333 2.74998 18.3333H19.25C19.7562 18.3333 20.1666 17.9229 20.1666 17.4166V4.58329C20.1666 4.07703 19.7562 3.66663 19.25 3.66663Z"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                              />
                              <path
                                id="Vector_2"
                                d="M7.79165 11.4583C8.80415 11.4583 9.62498 10.6375 9.62498 9.62496C9.62498 8.61246 8.80415 7.79163 7.79165 7.79163C6.77914 7.79163 5.95831 8.61246 5.95831 9.62496C5.95831 10.6375 6.77914 11.4583 7.79165 11.4583Z"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linejoin="round"
                              />
                              <path
                                id="Vector_3"
                                d="M10.5417 14.2084C10.5417 12.6896 9.31047 11.4584 7.79169 11.4584C6.27291 11.4584 5.04169 12.6896 5.04169 14.2084"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                id="Vector_4"
                                d="M12.8333 9.16663H16.5"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                id="Vector_5"
                                d="M13.75 12.8334H16.5"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                          </svg>

                          {{ $t("login.forgot_pass") }}</router-link
                        >
                      </div>
                      <div class="col text-center">
                        <router-link :to="{ name: 'app.login.forgot_email' }">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Icon/22/user">
                              <path
                                id="Vector"
                                d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                id="Vector_2"
                                d="M21 22C21 17.0294 16.9706 13 12 13C7.02945 13 3 17.0294 3 22"
                                stroke="#7385FC"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                          </svg>
                          {{ $t("login.forgot_email") }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="py-3">
                    <div class="d-flex list-policy justify-content-center">
                      <a
                        href=""
                        @click.prevent="contactDialog = !contactDialog"
                        >{{ $t("login.connect") }}</a
                      >
                      |
                      <a href="" @click.prevent="visiblePolicy = true">{{
                        $t("login.policy")
                      }}</a>
                      |
                      <a href="" @click.prevent="visibleSecurity = true">{{
                        $t("login.safe")
                      }}</a>
                    </div>
                  </div>
                  <div class="copyright mt-3 text-center text-muted wsp">
                    {{ $t("login.copyright") }}
                  </div>
                </form>
              </div>
            </div>
          </BCard>
        </BCol>
      </BRow>
    </div>
  </div>
</template>
<style>
span.svg-icon svg {
  width: 32px;
  height: 32px;
}
</style>
